var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
export var Gas = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8 0v.31a3.59 3.59 0 01-2.09 3.25 4.68 4.68 0 00-2.8 4.22A4.77 4.77 0 008 12.44v-.31a3.57 3.57 0 012.09-3.24 4.7 4.7 0 002.8-4.22A4.78 4.78 0 008 0z", fill: "currentColor" }),
    React.createElement("path", { d: "M1.33 14.22V16h13.34v-1.78z", fill: "currentColor", opacity: ".3" }))); };
